// Employer Page (Web Only - Pre-login)
// Displays supermedic.health/facilities in an iframe with the header cut off

import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import WebNavbar from '../../components/web/WebNavbar';
import { webColors, webSpacing } from '../../constants/webStyles';

// Height of the embedded site's header to cut off (adjust as needed)
const EMBEDDED_HEADER_HEIGHT = 80;

const EmployerScreen = () => {
  const navigation = useNavigation();
  const { loggedIn } = useSelector((state) => state.user);

  // Redirect logged-in users to their dashboard
  React.useEffect(() => {
    if (loggedIn) {
      navigation.replace('HomeScreen');
    }
  }, [loggedIn, navigation]);

  if (Platform.OS !== 'web') {
    return null;
  }

  return (
    <View style={styles.container}>
      <View style={styles.navbarContainer}>
        <WebNavbar variant="auth" />
      </View>
      <View style={styles.iframeWrapper}>
        <View style={styles.iframeContainer}>
          <iframe
            src="https://www.supermedic.health/facilities"
            style={styles.iframe}
            title="Employer - Supermedic Facilities"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: webColors.background,
    minHeight: '100vh',
  },
  navbarContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    paddingTop: 4,
    backgroundColor: 'white',
  },
  iframeWrapper: {
    flex: 1,
    width: '100%',
    height: `calc(100vh - ${webSpacing.navbarHeight}px)`,
    overflow: 'hidden',
    marginTop: webSpacing.navbarHeight,
  },
  iframeContainer: {
    width: '100%',
    height: `calc(100% + ${EMBEDDED_HEADER_HEIGHT}px)`,
    marginTop: -EMBEDDED_HEADER_HEIGHT,
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
});

export default EmployerScreen;
